import React from 'react'
import Select from 'react-select'

const DropdownIndicator = ({ data }) => (
  <div className="formselect__indicator formselect__dropdown-indicator">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M10 11.321l3.577-3.577c.326-.325.853-.325 1.179 0 .325.326.325.853 0 1.179l-4.167 4.166c-.325.326-.853.326-1.178 0L5.244 8.923c-.325-.326-.325-.853 0-1.179.326-.325.853-.325 1.179 0L10 11.321z"
        transform="translate(-136 -883) translate(136 883)"
      />
    </svg>
  </div>
)

const FormSelect = (props) => {
  return (
    <Select
      onBlur={props?.onBlur}
      className={`formselect`}
      classNamePrefix="formselect"
      closeMenuOnSelect
      isClearable={false}
      isSearchable={props.isSearchable || false}
      isDisabled={props.isDisabled || false}
      instanceId={props.instanceId}
      name={props.name}
      placeholder={props.placeholder}
      components={{ DropdownIndicator }}
      onChange={props.onChange}
      options={props.options}
      value={props.value}
    />
  )
}

export default FormSelect
